// extracted by mini-css-extract-plugin
export default {"stickable":"OrgsPageTemplate_stickable__mRbK4","placeHolderShimmer":"OrgsPageTemplate_placeHolderShimmer__sz750"};